import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import { MatTableDataSource, MatTabGroup } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OwnerShipService } from '../ownership.services';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
@Component({
    selector: 'app-ownership-list',
    templateUrl: './ownership-list.component.html',
    styleUrls: ['./ownership-list.component.scss']
})
export class OwnerShipListComponent implements OnInit, OnDestroy {
    processSource = new MatTableDataSource();
    evaluationsSource = new MatTableDataSource();
    signedSource = new MatTableDataSource();
    discardedSource = new MatTableDataSource();
    searchInput: FormControl;
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

    private _unsubscribeAll: Subject<any>;
    displayedColumns: string[] = [
        'address',
        'ubigeo_id',
        'updated_at',
        'percent',
        'phone',
        'id'
    ];

    _displayedColumns: string[] = [
        'address',
        'ubigeo_id',
        'updated_at',
        'percent',
        'status',
        'phone',
        'id'
    ];

    constructor(
        private activatedRoute: ActivatedRoute,
        private _appConfig: AppConfigService,
        private _router: Router,
        private _ownerShipService: OwnerShipService
    ) {
        this.searchInput = new FormControl('');
        this._unsubscribeAll = new Subject();
    }
    ngOnInit(): void {
        this._ownerShipService.localInProcessOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.processSource.data = local;
            });

        this._ownerShipService.localCompletedOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.evaluationsSource.data = local;
            });

        this._ownerShipService.localSignedOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.signedSource.data = local;
            });

        this._ownerShipService.localDiscardedOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.discardedSource.data = local;
            });

        this.searchInput.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe(searchText => {
                const index = this.tabGroup.selectedIndex;
                if (index === 0) {
                    this.processSource.filter = searchText;
                } else if (index === 1) {
                    this.evaluationsSource.filter = searchText;
                } else if (index === 2) {
                    this.signedSource.filter = searchText;
                } else {
                    this.discardedSource.filter = searchText;
                }
            });

        this.activatedRoute.queryParams.subscribe((params: Params) => {
            if (params['status']) {
                const _status = params['status'];
                if (_status === 'Pendiente') {
                    this.tabGroup.selectedIndex = 0;
                } else {
                    this.tabGroup.selectedIndex = 1;
                }
            }
        });
    }
    go(data) {
        if (data) {
            const steps = JSON.parse(data.steps);
            if (steps) {
                if (steps === -1) {
                    this._router.navigate([`/local/registro/2/${data.code}`]);
                } else {
                    const _step = this._ownerShipService.getDiffSteps(steps);
                    if (_step > 0) {
                        this._router.navigate([
                            `/local/registro/${_step}/${data.code}`
                        ]);
                    }
                }
            }
        }
    }
    detail(code) {
        this._router.navigate([`/admin/propiedades/list/${code}`]);
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    percentage(per): number {
        return parseInt(per, 0);
    }

    translateStatus(status) {
        let r = '';
        switch (status) {
            case 'COMPLETED':
                r = 'Completado';
                break;
            case 'ATTENDED':
                r = 'Atendido';
                break;

            case 'CONFIRMED':
                r = 'Confirmado';
                break;

            case 'GIVE-LOW':
                r = 'Baja';
                break;

            case 'VISIT-LOCAL':
                r = 'Visita local';
                break;
            case 'SIGNATURE-CONTRACT':
                r = 'Firmar contrato';
                break;
        }
        return r;
    }
}
